<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Security",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            title: "Security",
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            showOldPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
        };
    },
    computed: {
        ...mapGetters("auth", ["profile"]),
    },
    methods: {
        ...mapActions("auth", {
            changePass: "changePass",
        }),
        async changePassword() {
            var pl = {
                password: this.oldPassword,
                new_password: this.newPassword,
                new_password_confirmation: this.confirmPassword
            }

            const confirmed = await Swal.fire({
                title: `Change Password ?`,
                html: `Are you sure you want to change password?`,
                type: "warning",
                icon: "warning",
                confirmButtonColor: "#556ee6",
                showCancelButton: true,
                padding: "2em",
            }).then((result) => {
                return result.isConfirmed;
            });

            if (confirmed) {
                const res = await this.changePass(pl);
                console.log(res)
                if (res.message == "Password changed successfully!") {
                    Swal.fire({
                        title: "Success",
                        html: `Password Updated`,
                        type: "success",
                        icon: "success",
                        padding: "2em",
                    });
                    this.oldPassword = "";
                    this.newPassword = "";
                    this.confirmPassword = "";
                } else {
                    var error = res.message;
                    Swal.fire({
                        title: "Failed!",
                        icon: "error",
                        type: "error",
                        text: error
                    });
                }
            }

        },
        toggleVisibility(field) {
            if (field === "old") {
                this.showOldPassword = !this.showOldPassword;
            } else if (field === "new") {
                this.showNewPassword = !this.showNewPassword;
            } else if (field === "confirm") {
                this.showConfirmPassword = !this.showConfirmPassword;
            }
        },
    },
    mounted() {
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-3"></div>
            <div class="col-lg-6 disflex">
                <div class="card mb-2 p-2">
                    <div class="card-body">
                        <div class="disflex flex-column">
                            <label>Username:</label>
                            <span class="fw-bold fs-1">{{ profile.username }}</span>
                        </div>
                        <div class="disflex flex-column mt-4 mb-3">
                            <div class="disflex flex-column w-100">
                                <label>Old Password</label>
                                <div class="input-group">
                                    <input :type="showOldPassword ? 'text' : 'password'"
                                        class="form-control change-pass" placeholder="Enter old password..."
                                        v-model="oldPassword" />
                                    <span class="input-group-text" @click="toggleVisibility('old')">
                                        <i :class="showOldPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="disflex flex-column mb-3">
                            <div class="disflex flex-column w-100">
                                <label>New Password</label>
                                <div class="input-group">
                                    <input :type="showNewPassword ? 'text' : 'password'"
                                        class="form-control change-pass" placeholder="Enter new password..."
                                        v-model="newPassword" />
                                    <span class="input-group-text" @click="toggleVisibility('new')">
                                        <i :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="disflex flex-column mb-3">
                            <div class="disflex flex-column w-100">
                                <label>Confirm Password</label>
                                <div class="input-group">
                                    <input :type="showConfirmPassword ? 'text' : 'password'"
                                        class="form-control change-pass" placeholder="Enter confirm password..."
                                        v-model="confirmPassword" />
                                    <span class="input-group-text" @click="toggleVisibility('confirm')">
                                        <i :class="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="disflex mt-5">
                            <button class="changepass-btn" @click="changePassword()">Change Password</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3"></div>
        </div>
    </Layout>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: start;
}

.table> :not(caption)>*>* {
    text-align: center;
    padding: .5rem .1rem .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}
</style>